import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";

import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

import { Load_Data_Action, Login_Success_Action } from "../redux/actions";
import { useDispatch } from "react-redux";
import FetchData from "./fetchData";
import Loader from "./Loader";
import history from "./history";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "50%",
    marginLeft: "0",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn() {
  const classes = useStyles();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [loadingIndicator, setLoadingIndicator] = React.useState(false);
  const dispatch = useDispatch();
  const data = FetchData();

  function validateForm() {
    return userId.length > 0 && password.length > 0;
  }

  const login = async (event) => {
    event.preventDefault();
    setLoadingIndicator(true);
    let response = await fetch(
      "https://5ea5ac082d86f00016b460dd.mockapi.io/api/login/"
    );
    let resData = await response.json();
    console.log(resData);
    dispatch(
      Login_Success_Action({
        userid:resData.userid,
        displayName: resData.displayName,
        isLoggedIn: true,
        memberOf: resData.memberOf,
      })
    );
    dispatch(Load_Data_Action(data));
    if (true) {
      history.push("/servers");
    }
  };

  return (
    <Container>
      <CssBaseline />
      <Grid container xs={12} className={classes.sadsad}>
        <Grid item lg={2} className={classes.sdada}></Grid>
        <Grid item lg={8}>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form className={classes.form}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="userid"
                label="HLTCS ID"
                name="userId"
                autoFocus
                onChange={(e) => setUserId(e.target.value)}
                value={userId}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={login}
              >
                Sign In
              </Button>
            </form>
            <Loader loading={loadingIndicator} />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}
